import defaultPlayerImage from "@/assets/images/player.png";
import defaultPlayerWhiteImage from "@/assets/images/player-white.png";
import defaultAgentImage from "@/assets/images/agent.png";
import defaultAgentWhiteImage from "@/assets/images/agent-white.png";
import defaultTeamImage from "@/assets/images/club.png";
import defaultTeamWhiteImage from "@/assets/images/club-white.png";
import defaultCoachingStaffImage from "@/assets/images/agent.png";
import defaultCoachingStaffWhiteImage from "@/assets/images/agent-white.png";
import i18n from '@/i18n'
import Vue from 'vue'
import EnumService from "./EnumService";

export default class CommonService {
    onlyNumber($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if (keyCode < 48 || keyCode > 57) {
            $event.preventDefault();
        }
    }
    defaultPlayerAvatarUrl(event) {
        event.target.src = defaultPlayerImage;
    }
    defaultTeamAvatarUrl(event) {
        event.target.src = defaultTeamImage;
    }
    defaultAgentAvatarUrl(event) {
        event.target.src = defaultAgentImage;
    }
    defaultCoachingStaffAvatarUrl(event) {
        event.target.src = defaultAgentImage;
    }
    getCDNImageUrl(relativeImageUrl) {
        return Vue.prototype.$imageRootUrl + relativeImageUrl;
    }
    getPlayerAvatarUrl(avatar) {
        return avatar != null
            ? avatar.indexOf("data:") >= 0
                ? avatar
                : this.getCDNImageUrl(avatar)
            : this.getDefaultPlayerAvatarUrl();
    }
    getTeamAvatarUrl(avatar) {
        return avatar != null
            ? avatar.indexOf("data:") >= 0
                ? avatar
                : this.getCDNImageUrl(avatar)
            : this.getDefaultTeamAvatarUrl();
    }
    getAgentAvatarUrl(avatar) {
        return avatar != null
            ? avatar.indexOf("data:") >= 0
                ? avatar
                : this.getCDNImageUrl(avatar)
            : this.getDefaultAgentAvatarUrl();
    }
    getCoachingStaffAvatarUrl(avatar) {
        return avatar != null
            ? avatar.indexOf("data:") >= 0
                ? avatar
                : this.getCDNImageUrl(avatar)
            : this.getDefaultCoachingStaffAvatarUrl();
    }
    getDefaultAgentAvatarUrl() {
        return defaultAgentImage;
    }
    getDefaultAgentWhiteAvatarUrl() {
        return defaultAgentWhiteImage;
    }
    getDefaultPlayerAvatarUrl() {
        return defaultPlayerImage;
    }
    getDefaultPlayerWhiteAvatarUrl() {
        return defaultPlayerWhiteImage;
    }
    getDefaultTeamAvatarUrl() {
        return defaultTeamImage;
    }
    getDefaultTeamWhiteAvatarUrl() {
        return defaultTeamWhiteImage;
    }
    getDefaultCoachingStaffAvatarUrl() {
        return defaultAgentImage;
    }
    getDefaultCoachingStaffWhiteAvatarUrl() {
        return defaultAgentWhiteImage;
    }
    getAge(dateString) {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
            age--;

        return age;
    }
    openNewTab(url) {
        if (url != null)
            window.open(url, '_blank');
    }
    isYouthSection(id, isTier) {
        if (isTier)
            return (id == 15) ? true : false;
        else
            return (id == 3 || id == 4 || id == 5 || id >= 12) ? true : false;
    }
    getYouthSectionId(isTier) {
        return isTier ? 15 : 23;
    }
    getTirolibreLogoUrl(color) {
        return "assets/layout/images/tirolibre_logo_" + color + ".png";
    }
    getHomeImageUrl() {
        return "assets/images/home.svg";
    }
    getHomePlayerImageUrl() {
        return "assets/images/home-player.svg";
    }
    getHomePlayer2ImageUrl() {
        return "assets/images/home_player2.jpeg";
    }
    getHomePlayer3ImageUrl() {
        return "assets/images/strategic_representation.png";
    }
    getHomePlayer4ImageUrl() {
        return "assets/images/homa_player4.png";
    }
    getHomeContractImageUrl() {
        return "assets/images/contract.svg";
    }
    getHomeTeamImageUrl() {
        return "assets/images/home_team.svg";
    }
    getHomeTeam1ImageUrl() {
        return "assets/images/advanced_player_evaluation.png";
    }
    getHomeTeam2ImageUrl() {
        return "assets/images/smart_player_scouting.png";
    }
    getHomeNegotiationImageUrl() {
        return "assets/images/negotiation_room_club.png";
    }
    getHomeAgentImageUrl() {
        return "assets/images/home_agent.svg";
    }
    getHomeAgent2ImageUrl() {
        return "assets/images/home_agent2.jpeg";
    }
    getHomeAgent3ImageUrl() {
        return "assets/images/home_agent.svg";
    }
    getHomeAgent4ImageUrl() {
        return "assets/images/agent_start_negotiating.png";
    }
    getHomeAgent5ImageUrl() {
        return "assets/images/home_agent5.png";
    }
    getHomeAgent6ImageUrl() {
        return "assets/images/agent.svg";
    }
    getHomeAgent7ImageUrl() {
        return "assets/images/negotiation-room-agents.svg";
    }
    getHomeAffiliateImageUrl() {
        return "assets/images/home_affiliate.jpeg";
    }
    getHomePlayerTransfersImageUrl() {
        return "assets/images/revolutionizing_player_transfers.png";
    }
    getHomeRealTimeImageUrl() {
        return "assets/images/home_realtime.jpeg";
    }
    getHomeReportingImageUrl() {
        return "assets/images/reporting_section.png";
    }
    getHomeTeamsImageUrl() {
        return "assets/images/home_teams.jpg";
    }
    getAboutUs1ImageUrl() {
        return "assets/images/aboutus1.jpeg";
    }
    getAboutUs2ImageUrl() {
        return "assets/images/aboutus2.jpeg";
    }
    getTirolibreIconUrl() {
        return "assets/images/tirolibre_icon.png";
    }
    mapCategoryToLevel(category) {
        const enumService = new EnumService();
        switch (category) {
            case 0: // Serie A
            case 1: // Serie B
            case 2: // Serie C
                return enumService.getEnumName(enumService.getCategoryLevelEnum(), category);
            case 6: // Serie D
                return enumService.getEnumName(enumService.getCategoryLevelEnum(), 3);
            case 7: // Eccellenza
                return enumService.getEnumName(enumService.getCategoryLevelEnum(), 4);
            case 8: // Promozione
                return enumService.getEnumName(enumService.getCategoryLevelEnum(), 5);
            case 9: // Prima Categoria
                return enumService.getEnumName(enumService.getCategoryLevelEnum(), 6);
            case 10: // Seconda Categoria
                return enumService.getEnumName(enumService.getCategoryLevelEnum(), 7);
            case 11: // Terza Categoria
                return enumService.getEnumName(enumService.getCategoryLevelEnum(), 8);
        }
    }
    mapLevelToCategory(category) {
        const enumService = new EnumService();
        switch (category) {
            case 0:
            case 1:
            case 2:
                return category; // Serie A, Serie B, Serie C
            case 3:
                return 6;  // Serie D
            case 4:
                return 7; // Eccellenza
            case 5:
                return 8; // Promozione
            case 6:
                return 9; // Prima Categoria
            case 7:
                return 10; // Seconda Categoria
            case 8:
                return 11; // Terza Categoria
            default:
                return category;
        }
    }
    getCategoryName(categoryLevel, country) {
        const enumService = new EnumService();
        switch (country) {
            case "it":
            default:
                switch (categoryLevel) {
                    case 0: // Serie A
                    case 1: // Serie B
                    case 2: // Serie C
                        return enumService.getEnumName(enumService.getCategoryEnum(), categoryLevel);
                    case 3: // Serie D
                        return enumService.getEnumName(enumService.getCategoryEnum(), 6);
                    case 4: // Eccellenza
                        return enumService.getEnumName(enumService.getCategoryEnum(), 7);
                    case 5: // Promozione
                        return enumService.getEnumName(enumService.getCategoryEnum(), 8);
                    case 6: // Prima Categoria
                        return enumService.getEnumName(enumService.getCategoryEnum(), 9);
                    case 7: // Seconda Categoria
                        return enumService.getEnumName(enumService.getCategoryEnum(), 10);
                    case 8: // Terza Categoria
                        return enumService.getEnumName(enumService.getCategoryEnum(), 11);
                    case 15: // Settore giovanilie
                        return i18n.t('YouthSection');
                }
        }
    }
    createGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    getPublicPlayerReportUrl(playerId, playerName) {
        //return Vue.prototype.$rootSiteUrl + '/#/playerReport?playerId=' + playerId;
        return Vue.prototype.$rootSiteUrl + '/#/playerReport/' + playerId + '/' + playerName.trim().replace(/\s/g, '-');
    }
    getPublicPlayerReportUrlToShare(playerId, playerName) {
        return Vue.prototype.$serviceBaseUrl + '/api/player/playerReport/fb/' + playerId + '/' + playerName.trim().replace(/\s/g, '-');
    }
    formatFileSize(bytes) {
        if (bytes === 0) {
            return '0 B';
        }
        let k = 1000,
            dm = 3,
            sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
    UrlExists(url) {
        if (url.includes("null"))
            return false;
        let http = new XMLHttpRequest();
        http.open('HEAD', url, false);
        http.send();
        return http.status != 404;
    }
    checkChartValidExperiences(experiences) {
        const currentYear = new Date().getFullYear();
        const numberExperiencies = (experiences != null) ? experiences.length : 0;

        // also valid if the last season doesn't have team/experience
        if (
            numberExperiencies == 3 &&
            (currentYear == experiences[0].Season.EndYear ||
                currentYear ==
                experiences[0].Season.StartYear ||
                currentYear ==
                experiences[0].Season.EndYear + 1 ||
                currentYear ==
                experiences[0].Season.StartYear + 1) &&
            experiences[0].Division != null &&
            experiences[1].Division != null &&
            experiences[2].Division != null &&
            experiences[0].Season.StartYear != 0 &&
            experiences[1].Season.EndYear != 0 &&
            experiences[2].Season.EndYear != 0
        )
            return true;
        else return false;
    }
    isMobile() {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    }
    getWhatsappUrl(phoneNumber, message) {
        return "https://api.whatsapp.com/send?phone=" + phoneNumber + "&text=" + message
    }
    getRequestFacebookSharingUrl(requestId) {
        return Vue.prototype.$serviceBaseUrl + '/api/request/fb/' + requestId;
    }
    amountWithDots(x) {
        return (x !== null) ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + '€' : x;
    }
    numberWithDots(x) {
        return x.toLocaleString();
    }
}